/**
 * Project : workspace
 * File    : ScannerScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.common.scanner

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import component.navigation.TopNavBar
import navigation.AppNavigator

/**
 * Represents the scanner screen class.
 */

class ScannerScreen() {
    @Composable
     fun Content() {
        Column(
            modifier = Modifier
                .fillMaxSize()
        ) {
            TopNavBar("Scanner", onBackPress = {
                AppNavigator.shared().goBack()
            })
//            FriendlyScanner().Content()
        }
    }
}